import { notification } from "antd"
import { useMutation, useQuery, useQueryClient } from "react-query"
import { extractApiErrorMessage } from "../../helpers/apiErrorMessage"
import { deleteEmailTemplate, getEmailTemplates, saveEmailTemplate } from "./emailTemplateApi"

export const useEmailTemplatesQuery = () => {
  return useQuery({
    queryKey: ['email-templates'],
    queryFn: getEmailTemplates,
    staleTime: 30 * 1000
  })
}

export const useSaveEmailTemplateMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: saveEmailTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries((['email-templates']))
    },
    onError: (error: unknown) => {
      notification.error({
        message: 'There was a problem saving this email template.',
        description: extractApiErrorMessage(error, '') || undefined
      })
    }
  })
}

export const useDeleteEmailTemplateMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteEmailTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries((['email-templates']))
    },
    onError: (error: unknown) => {
      notification.error({
        message: 'There was a problem deleting this email template.',
        description: extractApiErrorMessage(error, '') || undefined
      })
    }
  })
}
